export default "__VITE_ASSET__0b2b83fc__"